import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setTag as sentrySetTag, setUser as sentrySetUser } from '@sentry/react'

import { UserState } from '../types/UserState'
import { VantageUser } from '../types/VantageUser'
import { analyticsIdentify } from '../utils/segment'

export const emptyUser: VantageUser = {
  id: 0,
  firstName: '',
  lastName: '',
  email: '',
  frontUserHash: '',
  isBrandUser: false,
  isRetailerUser: false,
  roles: [],
  activeRole: null,
  phone: '',
  orgCount: 0,
}

const initialState: UserState = {
  user: emptyUser,
  currentRole: undefined,
}

export const userSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<VantageUser>) {
      sentrySetUser({
        id: action.payload.id.toString(),
        email: action.payload.email,
        username: action.payload.firstName + ' ' + action.payload.lastName,
      })
      sentrySetTag('username', action.payload.email)
      const environment = (window as any).config?.environment
      analyticsIdentify({ user: action.payload, environment })
      state.user = action.payload
      state.currentRole = action.payload.activeRole || undefined
    },
    setCurrentRole(state, action: PayloadAction<string | undefined>) {
      state.currentRole = action.payload
    },
  },
})

export const { setUser, setCurrentRole } = userSlice.actions
